import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { menuItems } from '../NavbarSection/MenuItems';
import './Sidebar.css';

const Sidebar = ({ isOpen, onCloseSidebar }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleSubmenuToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onCloseSidebar();
    };

    document.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [isOpen, onCloseSidebar]);

  return (
    <>
      <div
        className={`sidebar-backdrop ${isOpen ? 'open' : ''}`}
        onClick={onCloseSidebar}
        aria-hidden="true"
      ></div>
      <div id="mobile-sidebar" className={`sidebar ${isOpen ? 'open' : ''}`} aria-hidden={!isOpen}>
        <button
          type="button"
          className="close-sidebar"
          onClick={onCloseSidebar}
          aria-label="Close menu"
          tabIndex={isOpen ? 0 : -1}
        >
          &times;
        </button>
        <ul className="menu2">
          {menuItems.map((menuItem, index) => (
            <li key={index} className="menu-item2">
              <Link
                to={menuItem.url}
                tabIndex={isOpen ? 0 : -1}
                onClick={() => {
                  if (menuItem.submenuItems.length === 0) onCloseSidebar();
                }}
              >
                {menuItem.title}
              </Link>
              {menuItem.submenuItems.length > 0 && (
                <>
                  <button
                    type="button"
                    className={`submenu2-toggle2 ${activeIndex === index ? 'active' : ''}`}
                    onClick={() => handleSubmenuToggle(index)}
                    aria-expanded={activeIndex === index}
                    aria-label={`Toggle ${menuItem.title} submenu`}
                    tabIndex={isOpen ? 0 : -1}
                  >
                    {activeIndex === index ? '-' : '+'}
                  </button>
                  <ul className={`submenu2 ${activeIndex === index ? 'open' : ''}`}>
                    {menuItem.submenuItems.map((submenuItem, subIndex) => (
                      <li key={subIndex} className="submenu2-item">
                        <Link
                          to={submenuItem.url}
                          tabIndex={isOpen ? 0 : -1}
                          onClick={onCloseSidebar}
                        >
                          {submenuItem.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </>
              )}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default Sidebar;
